import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup, AbstractControl } from '@angular/forms';
import { APIEntityService } from '../../_services/entity/API-entity';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { formatDate } from '@angular/common';
import { Constants } from '../../../../_utils/Constants';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { APITemplateService } from '../../_services/template/API-template';
import { APIHeaderService } from '../../_services/header/API-header';
import { Router, ActivatedRoute } from '@angular/router';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { saveAs as importedSaveAs } from "file-saver";


@Component({
  selector: 'app-bulk-template-verification',
  templateUrl: './bulk-template-verification.component.html',
  styleUrls: ['./bulk-template-verification.component.css']
})
export class BulkTemplateVerificationComponent implements OnInit {
  photoName: any;
  contentVerifyForm: FormGroup;
  fileExtensionError: boolean;
  myfiles: any[];
  fileUploaded: any;
  fileExtension: any;
  fileExtensionMessage: string;
  TemplateVerificationn: any;
  fileSizeError1: boolean;
  fileSizeError2: boolean;
  recorderror: boolean;
  isValid: boolean = false;
  worksheet: any;
  storeData: any;

  constructor(private fb: FormBuilder, private db: $DBManagerService, private es: APIEntityService, private $modal: $ModalManagerService,
    private router: Router,
    private hs: APITemplateService,
    private head: APIHeaderService) {

  }
  get f() { return this.contentVerifyForm.controls; }

  ngOnInit() {
    this.contentVerifyForm = this.fb.group({
      Entity_ID: ['', [Validators.required]],
      Organization_Name: ['',],
      Indus_Cat: ['',],
      TemplateVerificationn: ['', [Validators.required]],
      uploadSUP: ['',]
    });
    //let entityId = "1601100000000000459";
    let entityId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
    if (entityId == undefined || entityId == null) {
      this.router.navigateByUrl('/');
    }
    let org_type = this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_TYPE);
    let org_Name = this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_NAME);
    console.log("entityId", entityId, org_type, org_Name)
    // this.getTemplateIds();
    this.contentVerifyForm.controls['Entity_ID'].setValue(entityId);
    this.contentVerifyForm.controls['Organization_Name'].setValue(org_Name);

    if (org_type === 'P') {
      this.contentVerifyForm.controls['Indus_Cat'].setValue('private');
    } else if (org_type == 'G') {
      this.contentVerifyForm.controls['Indus_Cat'].setValue('Government');
    }
    else if (org_type == 'S') {
      this.contentVerifyForm.controls['Indus_Cat'].setValue('SEBI');
    } else if (org_type == 'U') {
      this.contentVerifyForm.controls['Indus_Cat'].setValue('Public Limited Company');
    }
  }

  resetForm() {
    this.contentVerifyForm.controls['TemplateVerificationn'].reset();
    this.TemplateVerificationn = null;
  }
  verificationreport(data) {
    var fileName, Entity_ID, data
    fileName = 'Bulk_Template_verification.xlsx';
    Entity_ID = this.contentVerifyForm.get('Entity_ID').value
    data = {
      Entity_ID: Entity_ID,
    }
    this.hs.verificationreport(data)
      .subscribe((r) => {
        importedSaveAs(r, fileName)
      })

  }
  onChangeFileUpload(event) {
    console.log("----------event---------", event)
    this.fileExtensionError = false;
    this.myfiles = [];
    this.fileUploaded = event.target.files[0];
    this.TemplateVerificationn = null;
    this.photoName = this.fileUploaded.name;
    let fileNameArr = this.photoName.split('.')
		if(fileNameArr.length>2){
      // this.fileDoubleExtensionError = true
      this.$modal.errorModal({
        title: 'Bulk Template Verification',
        msg: 'File with double extension is not allowed!' 
      })
      this.resetKYC(0)
    }else{
      var allowedExtensions =
      // ["csv", "xls"];
      ["xlsx"];
    this.fileExtension = this.fileUploaded.name.split('.').pop();
    console.log("hello")
    if (this.isInArray(allowedExtensions, this.fileExtension)) {
      this.fileExtensionError = false;
      this.fileExtensionMessage = ""
    } else {
      this.TemplateVerificationn = null;
      this.fileExtensionMessage = "Only photos allowed!!"
      this.fileExtensionError = true;
      this.$modal.errorModal({
        title: 'Wrong Format',
        msg: 'Please select only Excel file format to upload'
      });
      return true;
    }

    this.myfiles.push(event.target.files[0])
    console.log("herere", this.myfiles);
    this.TemplateVerificationn = this.myfiles;


    if (this.fileUploaded.size > 4242880) {
      console.log("The size is more ")
      this.fileSizeError1 = true;
      this.TemplateVerificationn = null;
    }
    else {
      this.fileSizeError1 = false;
    }
    if (this.fileUploaded.size <= 0) {
      console.log("The size is less ")
      this.fileSizeError2 = true;
      this.TemplateVerificationn = null;
    }
    else {
      this.fileSizeError2 = false;
    }
    if (this.isValidxlsxFile(event.target.files[0])) {
      this.readExcel(event.target.files[0]);
    }
    }
  }
  isValidxlsxFile(file: any) {
    return file.name.endsWith(".xlsx");
  }
  resetKYC(index) {
    this.myfiles.splice(index, 1)
    this.contentVerifyForm.controls['TemplateVerificationn'].reset();
    this.TemplateVerificationn = null;
    this.myfiles = null;
  }


  readExcel($event: any) {

    this.recorderror = false
    let readFile = new FileReader();
    readFile.onload = (e) => {
      this.storeData = readFile.result;
      var data = new Uint8Array(this.storeData);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");
      var workbook = XLSX.read(bstr, { type: "binary" });
      var first_sheet_name = workbook.SheetNames[0];
      this.worksheet = workbook.Sheets[first_sheet_name];
      this.TemplateVerificationn = this.myfiles;

      var xlsrec = XLSX.utils.sheet_to_json(workbook.Sheets[first_sheet_name], { header: 1 });
      console.log("------------xlsrec--------", xlsrec)
      if (xlsrec && xlsrec.length) {
        if (xlsrec.length <= 1) {
          this.$modal.errorModal({
            title: 'Bulk Template Verification',
            msg: 'Please upload atleast one data record',
          });
          this.recorderror = true
        }
        console.log("----------xlsrec[0][0]------", xlsrec[0][0])
        if ((xlsrec[0][0] == "URN") && (xlsrec[0][1] == "Template_ID") && (xlsrec[0][2] == "Header_Cli") && (xlsrec[0][3] == "Template_Name") && (xlsrec[0][4] == "Content_Type") && (xlsrec[0][5] == "Communication_Type") && (xlsrec[0][6] == "Category") && (xlsrec[0][7] == "Registration_Date") && (xlsrec[0][8] == "Content") &&(xlsrec[0][9] == "No_of_variables") && (xlsrec[0][10] == "Justification") && (xlsrec[0][11] == "Verify")) {

          console.log("Valid CSV Contents")
          this.TemplateVerificationn = this.myfiles;
        }

        else {

          this.$modal.errorModal({
            title: 'Bulk Template Verification',
            msg: 'Wrong Content. Please Upload a Xlsx with Valid Contents'
          });
          this.recorderror = true;
        }
      }
      else {
        this.$modal.errorModal({
          title: 'Bulk Template Verification',
          msg: 'Please upload atleast one record',
        });
        this.recorderror = true;
        this.isValid = true;
      }

    }


    readFile.readAsArrayBuffer(this.fileUploaded);
    console.log(this.fileUploaded);
  }

  onSubmit() {

    if (this.contentVerifyForm.invalid) {
      this.$modal.errorModal({
        title: 'Error',
        msg: 'Please upload a File'
      });
      return;
    }
    else {
      if (this.recorderror == false) {
        const file1: any = document.getElementById('TemplateVerificationn');
        let Entity_ID = this.contentVerifyForm.get("Entity_ID").value;
        const contentForm: FormData = new FormData();
        console.log("file1 ", file1);
        console.log(" file1.files[0] ", file1.files[0])
        contentForm.append('test', "test");
        contentForm.append('TemplateVerification', file1.files[0]);
        contentForm.append('Entity_ID', Entity_ID);
        this.hs.updateTmpVerification(contentForm)
          .subscribe(r => {
            console.log("r ----> ", r);
            if (r.status == "success") {
              this.$modal.successModal({
                title: 'Bulk Template Verification',
                msg: r.message
              });
              this.router.navigateByUrl('/bulk-template-verification-summary');

            }
            else {
              this.$modal.errorModal({
                title: 'Bulk Template Verification',
                msg: r.message
              });
              this.contentVerifyForm.controls['TemplateVerificationn'].reset();
              this.TemplateVerificationn = null;
              this.myfiles = null;
            }
          })
      }
    }
  }
  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }
}
